import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Mission } from 'src/app/shared/models/mission/mission';

@Component({
	selector: 'app-reorder-route',
	templateUrl: './reorder-route.component.html',
	styleUrls: ['./reorder-route.component.scss']
})
export class ReorderRouteComponent implements OnInit {
	@Input() missionList: Mission[];

	missionListCopy: Mission[];

	constructor(
		private bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {
		this.missionListCopy = [...this.missionList];
	}

	draggingIndex: number;
	fromIndex: number;
	toIndex: number;

	isBtnValidateClicked = false;

	onDragStart(fromIndex: number): void {
		this.draggingIndex = fromIndex;
	}

	onDragEnter(toIndex: number): void {
		if (this.draggingIndex !== toIndex) {
			this._reorderItem(this.draggingIndex, toIndex);
		}
	}

	onDragEnd(): void {
		this.draggingIndex = undefined;
	}

	private _reorderItem(fromIndex: number, toIndex: number): void {
		const itemToBeReordered = this.missionListCopy.splice(fromIndex, 1)[0];
		this.missionListCopy.splice(toIndex, 0, itemToBeReordered);
		this.draggingIndex = toIndex;
	}

	closeModal() {
		this.bsModalRef.hide();
	}

	validateChange() {
		this.isBtnValidateClicked = true;

		// const missionListCopy = this.missionListCopy.slice(0);
		const missionListForBackend = [];

		// On cherche la nouvelle position de chaque mission dans la nouvelle liste réordonnée
		this.missionList.forEach((originalMission, formerIndex) => {
			const indexOfMissionInNewList = this.missionListCopy.findIndex(
				(mission) => mission.id === originalMission.id
			);
			// Si la mission a été déplacé, on l'ajoute à la liste des missions à update
			if (indexOfMissionInNewList !== formerIndex) {
				const changedMission = this.missionListCopy[indexOfMissionInNewList];
				changedMission.plannedPosition = indexOfMissionInNewList; // on met à jour la plannedPosition de la mission
				missionListForBackend.push(
					this.missionListCopy[indexOfMissionInNewList]
				);
			}
		});

		this.facade.missionService
			.updateMissionOrder(missionListForBackend)
			.subscribe({
				next: () => {
					this.isBtnValidateClicked = false;
					this.missionList = [...this.missionListCopy];
					this.missionList.forEach(
						(mission, index) => (mission.plannedPosition = index)
					);
					this.closeModal();
				},
				error: (err: ErrorResponse) => {
					this.isBtnValidateClicked = false;
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}

	/**
	 * Change la plannedPosition de la mission à l'index missionIndex de la route à l'index routeIndex de listRoute
	 * @param index 1 ou -1 en fonction du bouton cliquer
	 * @param missionIndex positon de la mission dans le tableau de la route correspondante
	 */
	changeIndexOfMissionFromRoute(index: number, missionIndex: number) {
		const itemToBeReordered = this.missionListCopy.splice(missionIndex, 1)[0];
		this.missionListCopy.splice(missionIndex + index, 0, itemToBeReordered);
	}
}
